module.exports = __webpack_public_path__ + "static/img/24.e52ee73.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rz/24.jpg
// module id = m/Da
// module chunks = 0